export const SHOW_BOOKS = "books/showBooks";
export const ADD_BOOK = "books/create";
export const UPDATE_BOOK = "books/update";
export const DELETE_BOOK = "books/delete";
export const CHANGE_OPERATION = "books/changeOperation";
export const SELECT_CANDIDATE = "books/select";
